module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/119-brunei-428d361b4b5763c4b819f3c7fd4cc096.svg";